<template>
    <img :src="imageUrl" class="avatar" alt="Avatar" />
</template>

<script>
export default {
    name: 'Avatar',
    props: {
        imageUrl: {
            type: String,
            default: '',
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.avatar {
    $avatar-size: 32px;
    width: $avatar-size;
    height: $avatar-size;
    border-radius: $avatar-size;
    object-fit: cover;
    vertical-align: middle;
}
</style>
